import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errDetail } from "./api";

/** Deep link support: /module?id=<recordId> fetches the record and opens its detail/edit view. */
export function useOpenById(module, onOpen, paramName = "id") {
  const [params, setParams] = useSearchParams();
  const cb = useRef(onOpen);
  cb.current = onOpen;

  useEffect(() => {
    const id = params.get(paramName);
    if (!id) return;
    api.get(`/${module}/${id}`).then((r) => cb.current(r.data)).catch((e) => toast.error(errDetail(e)));
    const next = new URLSearchParams(params);
    next.delete(paramName);
    setParams(next, { replace: true });
  }, [params, setParams, module, paramName]);
}
